import React from "react";
import { useTranslation } from "react-i18next";

const TERMS_CONTENT_HE = (
  <>
    <h2>תנאי שימוש ופרטיות</h2>
    <p><strong>תנאי שימוש</strong></p>
    <p>עודכן לאחרונה: 18 במרץ 2026</p>
    <p>מפעילת האתר: סורפס 3.0 בע"מ, ח.פ. 513826883 ("החברה")</p>
    <p>יצירת קשר: HQ@surpass.co.il</p>

    <h3>הקדמה והסכמה</h3>
    <p>1. האתר masav.surpass.co.il ("האתר") מופעל על-ידי החברה ומספק כלי מקוון ליצירה, הכנה והפקה של קבצי מס"ב ("השירות"), בהתאם למידע שמוזן על-ידי המשתמש.</p>
    <p>2. מסמך זה מסדיר את תנאי השימוש באתר ובשירותי האתר, וכן את מדיניות הפרטיות החלה על איסוף ושימוש במידע אישי במסגרת השימוש באתר (ביחד: "המסמך").</p>
    <p>3. השימוש באתר, לרבות גלישה, הזנת נתונים, יצירת קבצים, הורדה/ייצוא, הרשמה ו/או יצירת קשר, מותנה בקריאה ובהסכמה מלאה לתנאי מסמך זה ("התנאים"). אם אינך מסכים לתנאים, עליך להימנע מכל שימוש באתר. כל שימוש מהווה הסכמה מלאה למסמך זה. אם אינך מסכים, עליך להימנע משימוש באתר.</p>
    <p>4. המסמך מנוסח בלשון זכר מטעמי נוחות בלבד ומתייחס לכל המגדרים. כותרות נועדו לנוחות ולא ישמשו לפרשנות.</p>
    <p>5. החברה רשאית לעדכן את התנאים מעת לעת. נוסח התנאים המעודכן שיפורסם באתר הוא המחייב. המשך שימוש לאחר עדכון ייחשב להסכמה לנוסח המעודכן.</p>

    <h3>הגדרות</h3>
    <p>6. "משתמש": כל אדם ו/או תאגיד ו/או מי מטעמם, המשתמש באתר ו/או בשירות.</p>
    <p>7. "תוכן משתמש": כל נתון, מידע, קובץ, טקסט, מספר, פרטי בנק, פרטי מוטב/משלם, סכומים, תאריכים, מזהים (לרבות תעודת זהות/ח״פ/מס׳ מוסד), וכיו״ב, שהמשתמש מזין ו/או מעלה ו/או מייצא באמצעות האתר.</p>
    <p>8. "תוצר": כל פלט הנוצר באמצעות השירות, לרבות קובץ מס״ב ו/או קבצי עזר/דו״חות/מסכי סיכום, ככל שיופקו.</p>

    <h3>תיאור השירות והיקף אחריות המפעילה</h3>
    <p>9. השירות הוא כלי טכני-תפעולי להכנת קובץ/קבצים על בסיס תוכן המשתמש. השימוש בשירות אינו מהווה, ואינו מחליף, ייעוץ מקצועי מכל סוג (חשבונאי, פיננסי, מיסויי, משפטי, רגולטורי, אבטחת מידע או אחר).</p>
    <p>10. החברה אינה מספקת שירותי תשלום, אינה משמשת כמתווך תשלומים, אינה צד לשידור הקבצים למס״ב/לבנק/לגוף פיננסי, ואינה אחראית לשידור, קליטה, אישור, דחייה, החזרה, ביטול או ביצוע בפועל של תשלומים/חיובים מכל סוג.</p>
    <p>11. המפעילה אינה מציגה כל מצג, התחייבות או הבטחה שלפיהם:</p>
    <p className="sub-clause">11.1. התוצר יעמוד בכל דרישת מפרט, נוהל או תקן (לרבות עדכונים עתידיים);</p>
    <p className="sub-clause">11.2. התוצר ייקלט או יאושר על-ידי מס״ב/בנק/גורם חיצוני;</p>
    <p className="sub-clause">11.3. התוצר יביא לתוצאה פיננסית כלשהי או ימנע תקלות/החזרות/שגיאות/קנסות.</p>

    <h3>שימוש מותר והתחייבות לשימוש עצמי בלבד</h3>
    <p>12. השירות מיועד לשימוש עצמי בלבד: המשתמש רשאי להשתמש בשירות לצורך יצירה והפקה של קבצי מס״ב עבור עצמו ו/או עבור התאגיד שבו הוא עובד או שהוסמך לפעול בשמו, ורק לצרכיו הפנימיים והישירים של אותו משתמש/תאגיד.</p>
    <p>13. מבלי לגרוע מהאמור, המשתמש אינו רשאי:</p>
    <p className="sub-clause">13.1. להפיק קבצי מס״ב עבור צדדים שלישיים (לרבות לקוחות, ספקים, מעסיקים אחרים, גופים קשורים, או כל גורם שאינו "המשתמש" כהגדרתו), כפעילות שירות, לשכה ו/או מיקור-חוץ;</p>
    <p className="sub-clause">13.2. למכור, להשכיר, להעמיד לרשות ציבור, להעניק רישיון משנה, או למסחר את השירות או את התוצר;</p>
    <p className="sub-clause">13.3. לבצע "שימוש מרובה-דיירים" (multi-tenant) או לאפשר שימוש בקבוצות שאינן חלק מאותו משתמש/תאגיד;</p>
    <p className="sub-clause">13.4. לספק פרטי התחברות/גישה לצד ג׳ או לאפשר לאחר להשתמש בחשבון המשתמש;</p>
    <p className="sub-clause">13.5. לעקוף מגבלות טכניות, לבצע הנדסה לאחור, לשבש את האתר, לבצע scraping/שאיבת מידע או שימוש אוטומטי בלתי מורשה;</p>
    <p className="sub-clause">13.6. להשתמש באתר לכל מטרה בלתי חוקית ו/או באופן הפוגע בזכויות צד ג׳.</p>
    <p>14. המפעילה רשאית לדרוש בכל עת הוכחה להרשאה, זהות, שיוך ארגוני, ולחסום שימוש שאינו עומד בדרישות סעיף זה.</p>

    <h3>חשבון משתמש, הזדהות ואבטחת פרטי גישה</h3>
    <p>15. ייתכן שחלק מהשירותים ידרשו פתיחת חשבון, הזדהות או מסירת פרטים. המשתמש מתחייב למסור פרטים נכונים, מלאים ומעודכנים, ולעדכנם בעת שינוי.</p>
    <p>16. המשתמש אחראי לשמירה על סודיות פרטי הגישה, וכל פעולה שתבוצע באמצעות חשבונו תיחשב כאילו בוצעה על-ידיו.</p>
    <p>17. במקרה של חשד לשימוש בלתי מורשה, המשתמש מתחייב להודיע למפעילה ללא דיחוי ולנקוט בכל פעולה סבירה לצמצום נזק.</p>

    <h3>תוכן משתמש, הרשאות וחובות המשתמש</h3>
    <p>18. המשתמש מצהיר ומתחייב כי:</p>
    <p className="sub-clause">18.1. יש לו כל זכות, הרשאה והסכמה נדרשות להזין את תוכן המשתמש בשירות, לרבות ביחס לפרטי צדדים שלישיים (עובדים, ספקים, לקוחות, מוטבים, משלמים וכיו״ב);</p>
    <p className="sub-clause">18.2. הוא פועל בהתאם לכל דין החל עליו (לרבות דיני פרטיות, דיני עבודה, דיני מס ועוד, לפי עניינו);</p>
    <p className="sub-clause">18.3. תוכן המשתמש אינו מפר זכויות קניין רוחני, פרטיות או כל זכות אחרת של צד ג׳.</p>
    <p className="sub-clause">18.4. המשתמש אחראי באופן בלעדי לאימות, בדיקה ובקרה של תוכן המשתמש ושל כל תוצר (לרבות בדיקת סכומים, זהויות, פרטי חשבון, תאריכים, קודי בנק/סניף/חשבון, שדות חובה, איזונים וסיכומים).</p>
    <p className="sub-clause">18.5. המשתמש מתחייב לשמור עותק עצמאי של תוכן המשתמש ושל כל תוצר שהופק, ולנקוט גיבוי פנימי בהתאם לצרכיו ולדרישותיו.</p>

    <h3>קניין רוחני</h3>
    <p>19. כל זכויות הקניין הרוחני באתר ובשירות (לרבות קוד, עיצוב, ממשק, טקסטים, סימני מסחר, לוגואים, תיעוד ומודלים) שייכות למפעילה ו/או למי שהרשה לה שימוש בהם, ואין בתנאים אלה כדי להקנות למשתמש זכויות כלשהן מעבר לרישיון שימוש מוגבל.</p>
    <p>20. בכפוף לתנאים אלה, המפעילה מעניקה למשתמש רישיון שימוש אישי, מוגבל, בלתי בלעדי, בלתי ניתן להעברה וללא זכות לרישיון משנה, לצורך שימוש בשירות בהתאם לתנאים.</p>
    <p>21. המשתמש מעניק למפעילה את כל הזכויות על מנת לעבד את תוכן המשתמש לצורך מתן השירות, תפעולו, אבטחתו, שיפורו ותמיכתו.</p>

    <h3>פרטיות ואבטחת מידע</h3>
    <p>22. המפעילה נוקטת באמצעי אבטחה מקובלים כדי להגן על האתר ועל המידע; עם זאת, אין אפשרות להבטיח אבטחה מוחלטת, והמשתמש מאשר כי שימוש באינטרנט כרוך בסיכונים מובנים.</p>
    <p>23. המשתמש מסכים כי המפעילה רשאית להיעזר בספקי משנה (לרבות שירותי ענן, ניטור, אבטחה, אנליטיקה ותמיכה) לצורך מתן השירות, ובלבד שהדבר ייעשה בהתאם למדיניות הפרטיות ובהיקף הנדרש למימוש השירות.</p>
    <p>24. החברה מכבדת את פרטיות המשתמשים ופועלת בהתאם לדין הישראלי החל.</p>
    <p>25. לצורכי פרטיות, עשויות להתקיים שתי מסגרות: מידע שבו החברה היא "בעל שליטה" (למשל פרטי חשבון משתמש, חיוב, פניות תמיכה, נתוני שימוש/לוגים); וכל תוכן משתמש שהמשתמש מעלה, לרבות למטרת הפקת קובץ מס״ב.</p>
    <p>26. החברה עשויה לאסוף ו/או לעבד כל תוכן משתמש או מידע באתר, לרבות:</p>
    <p className="sub-clause">26.1. פרטי חשבון והרשמה: שם, דוא״ל, טלפון, תפקיד/ארגון, פרטי אימות;</p>
    <p className="sub-clause">26.2. נתוני שימוש טכניים: כתובת IP, מזהי מכשיר/דפדפן, לוגים, תיעוד גישה;</p>
    <p className="sub-clause">26.3. תוכן משתמש לצורך הפקת קובצי מס״ב: פרטי בנק/סניף/חשבון, פרטי מוטבים/משלמים, סכומים, תאריכים, מזהים (למשל ת״ז/ח״פ), מזהה עסקה, אסמכתאות תשלום;</p>
    <p className="sub-clause">26.4. פניות ותכתובות: תוכן פנייה ותיעוד טיפול.</p>
    <p>27. החברה תעבד מידע אישי לפי שיקול דעה לרבות לצרכים כגון:</p>
    <p className="sub-clause">27.1. מתן השירות ותפעולו (יצירת תוצרים, תמיכה);</p>
    <p className="sub-clause">27.2. אבטחת מידע, מניעת הונאה ושימוש לרעה;</p>
    <p className="sub-clause">27.3. חיוב/גבייה וניהול חשבונות;</p>
    <p className="sub-clause">27.4. שיפור השירות, ניטור תקלות וסטטיסטיקות;</p>
    <p className="sub-clause">27.5. ציות לדרישות דין/אכיפה/ניהול מחלוקות;</p>
    <p className="sub-clause">27.6. שיווק/דיוור – רק בכפוף לדין ולהסכמות הנדרשות.</p>
    <p>28. החברה נוקטת באמצעים טכניים וארגוניים סבירים ומקובלים להגנה על מידע, כגון בקרות הרשאה, הצפנה וכיו"ב. עם זאת אין אפשרות להבטיח אבטחה מוחלטת.</p>
    <p>29. החברה תשמור מידע לתקופה הדרושה למימוש מטרות העיבוד, לניהול מחלוקות, לציות לדין, ולהגנה משפטית, ועל פי דין.</p>
    <p>30. ניתן לפנות לחברה למימוש זכויות עיון/תיקון/מחיקה בהתאם לדין, בכתובת יצירת הקשר לעיל. החברה עשויה לבקש אימות זהות לפני מענה.</p>
    <p>31. האתר עשוי להשתמש ב-Cookies וטכנולוגיות דומות (Pixels/Web beacons) לצרכי תפעול, אבטחה, מדידה ושיפור חוויית שימוש, ולעיתים גם פרסום/שיווק.</p>
    <p>32. ניתן לנהל/לחסום קוקיות דרך הגדרות דפדפן; ייתכן שחסימה תפגע בפונקציונליות.</p>

    <h3>שירותי צדדים שלישיים</h3>
    <p>33. האתר עשוי לכלול קישורים, הפניות או אינטגרציות לשירותים, אתרים ו/או תכנים של צדדים שלישיים. שירותים אלה אינם בשליטת המפעילה ועשויים להיות כפופים לתנאים ומדיניות פרטיות נפרדים.</p>
    <p>34. המפעילה אינה אחראית לשירותי צד ג׳, לתקינותם, לזמינותם, למדיניותם או לכל נזק הנובע מהם.</p>

    <h3>זמינות, תמיכה, שינויים והפסקת השירות</h3>
    <p>35. המפעילה רשאית לשנות, לעדכן, להוסיף או לגרוע פונקציות בשירות, וכן לבצע תחזוקה, להשבית או להגביל זמנית את השירות, לפי שיקול דעתה ובהתאם לצרכים תפעוליים/אבטחתיים.</p>
    <p>36. המפעילה אינה מתחייבת לזמינות רציפה, רציפות עסקית, או SLA, אלא אם הוסכם אחרת בכתב.</p>
    <p>37. המפעילה רשאית להפסיק את מתן השירות (כולו או חלקו) לכל משתמש או בכלל, לרבות עקב הפרת תנאים, חשד לשימוש אסור, דרישת דין, או צורך אבטחתי או טכני.</p>

    <h3>סיום, מחיקה ושמירת נתונים</h3>
    <p>38. המשתמש רשאי להפסיק שימוש בכל עת.</p>
    <p>39. המפעילה רשאית להשעות, לחסום ו/או להפסיק שימוש של משתמש, בכל עת וללא הודעה מוקדמת.</p>
    <p>40. עם סיום/הפסקת השירות, המפעילה רשאית (אך אינה חייבת) למחוק תוכן משתמש ותוצרים המוחזקים אצלה, בכפוף לדין החל ולמדיניות הפרטיות. על המשתמש לדאוג להורדת עותקים מבעוד מועד.</p>

    <h3>תשלומים, חיוב וביטולים</h3>
    <p>41. השימוש באתר עשוי להיות חינמי או בתשלום (מנוי או תשלום לפי שימוש), לפי המודל שיפורסם באתר מעת לעת.</p>
    <p>42. במקרה של שירות בתשלום, התשלום הוא עבור זכות השימוש בשירות, ולא עבור ביצוע תשלומים בפועל או קליטת קבצים במס״ב.</p>
    <p>43. המפעילה רשאית לשנות תעריפים, מסלולים, תקופות ניסיון ותנאי חיוב, בכפוף לדין החל ובכפוף לפרסום באתר.</p>
    <p>44. ככל שחלה על המשתמש זכות ביטול או החזר מכוח דין שאינו ניתן להתניה (לרבות הוראות רלוונטיות בדיני הגנת הצרכן, ככל שחלים), הוראות הדין יגברו.</p>

    <h3>היעדר אחריות, פטור מאחריות והגבלת אחריות</h3>
    <p>45. האתר, השירות וכל התוצרים מסופקים כמות שהם ("As-Is") ללא מצגים או אחריות מכל סוג, מפורשת או משתמעת, לרבות התאמה למטרה מסוימת, אי-הפרה, זמינות, דיוק, שלמות או עדכניות.</p>
    <p>46. האחריות המלאה והבלעדית לתוכן המשתמש, לתוצר, לשימוש בתוצר, לשידור קבצי מס״ב, לקליטתם ולתוצאותיהם, חלה על המשתמש בלבד.</p>
    <p><strong>פטור מאחריות:</strong></p>
    <p>47. החברה ו/או מי מטעמה (ובעליה, עובדיה, ספקיה וכיו"ב) לא תישא בכל אחריות לכל נזק, הפסד, הוצאה, חיוב, שומה, קנס או תביעה מכל סוג, הנובעים במישרין או בעקיפין מן השימוש באתר/בשירות/בתוצר, לרבות (ומבלי למצות): תשלומים שגויים, שידור שגוי, דחיית קובץ, כשל קליטה, השבת תשלום/חיוב, אי התאמה למפרט מס״ב, אובדן נתונים, השבתה, או פגיעה במוניטין.</p>
    <p>48. בכל מקרה לא תישא המפעילה באחריות לכל נזק מכל סוג שהוא, לרבות נזקים ישירים, עקיפים, תוצאתיים, מיוחדים, עונשיים, אגביים, אובדן רווחים, אובדן הכנסות, אובדן מוניטין, אובדן הזדמנויות עסקיות, ו/או אובדן או שיבוש מידע.</p>
    <p>49. ככל שבית משפט מוסמך יקבע חרף האמור כי מוטלת על המפעילה אחריות, אזי אחריותה המצטברת לכלל הנזקים והתביעות בקשר עם השירות לא תעלה על הנמוך מבין: הסכום המצטבר ששילם המשתמש בפועל למפעילה עבור השימוש בשירות במהלך שלושת (3) החודשים שקדמו לאירוע; או 100 ש״ח (אם השירות ניתן ללא תשלום).</p>
    <p>50. אין באמור כדי לגרוע מאחריות שאינה ניתנת להגבלה החרגה לפי דין, ככל שחלה.</p>

    <h3>שיפוי</h3>
    <p>51. המשתמש מתחייב לשפות ולפצות את החברה ו/או מי מטעמה (ובעליה, עובדיה, ספקיה וכיו"ב) בגין כל תביעה, דרישה, נזק, הפסד, קנס, הוצאה (לרבות שכ״ט עו״ד סביר) הנובעים או קשורים ל:</p>
    <p className="sub-clause">51.1. שימוש המשתמש בשירות ובתוצר;</p>
    <p className="sub-clause">51.2. הפרת תנאים אלה;</p>
    <p className="sub-clause">51.3. הפרת דין על-ידי המשתמש;</p>
    <p className="sub-clause">51.4. כל טענה של המשתמש ו/או של צד ג׳ ביחס לתוכן המשתמש, להרשאות שלא ניתנו, או לתשלומים, חיובים שבוצעו, שודרו על בסיס התוצר, לרבות שגיאות ו/או טעויות.</p>

    <h3>משלוח הודעות</h3>
    <p>52. המפעילה רשאית לשלוח למשתמש הודעות תפעוליות ו/או שירותיות בכל אמצעי קשר שסופק, לרבות דוא״ל, טלפון, וכיו"ב ו/או ממשק האתר.</p>
    <p>53. הודעות שיווקיות, ככל שישלחו, יישלחו רק בהתאם לדין החל ובהתאם להסכמות המשתמש (ככל שנדרשות).</p>

    <h3>שונות</h3>
    <p>54. כותרות הסעיפים בהסכם זה ניתנו למען הנוחות בלבד ואין ליתן להן כל משקל בפרשנות ההסכם.</p>
    <p>55. על תנאים אלה יחולו דיני מדינת ישראל בלבד.</p>
    <p>56. סמכות השיפוט הבלעדית בכל מחלוקת הנובעת מתנאים אלה או מהשימוש באתר תהא נתונה לבתי המשפט המוסמכים במחוז תל-אביב–יפו.</p>
    <p>57. אי-אכיפה של זכות אינה מהווה ויתור. אם סעיף בתנאים ייקבע כבלתי אכיף, יתר הסעיפים יישארו בתוקף, ובמקום הסעיף יוחל סעיף אכיף הקרוב ביותר לתכליתו.</p>
    <p>58. המפעילה רשאית להמחות זכויות וחובות לפי תנאים אלה לתאגיד קשור/רוכש פעילות, והמשתמש מאשר זאת מראש; המשתמש אינו רשאי להמחות זכויותיו ללא הסכמת המפעילה מראש ובכתב.</p>
    <p>59. תנאים אלה מהווים את ההסכם המלא בין הצדדים ביחס לשימוש באתר, וגוברים על מצגים ו/או הבנות קודמות שלא עוגנו בכתב.</p>
  </>
);

export const TermsPage = () => {
  const { t } = useTranslation("translation");

  return (
    <div
      style={{
        direction: t("direction"),
        maxWidth: "800px",
        width: "100%",
        height: "100%",
        margin: "0 auto",
        padding: "24px 16px 48px",
        lineHeight: 1.7,
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        className="terms-content"
        style={{
          background: "#fff",
          padding: "32px",
          borderRadius: "8px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          overflowX: "hidden",
          maxWidth: "100%",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        {TERMS_CONTENT_HE}
      </div>
    </div>
  );
};
